import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/core/core.state'
import { Member } from 'src/app/features/member/member'
import { memberActions } from 'src/app/features/member/member.actions'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { CompetitionTeam } from '../competition-team'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CompetitionTeamCreationConfirmationModalComponent
  implements OnInit
{
  @Input() teamsOfMember: CompetitionTeam[]
  @Output() onSubmit = new EventEmitter<any>()
  public isLoading$: Observable<boolean>
  public selectedMember: Member
  public members$: Observable<Member[]>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {}

  public onSearchMember(term: string) {
    this.store.dispatch(
      memberActions.searchManyByParams({
        // TODO should shift to another endpoint as /members is now for admins only
        params: RequestQueryBuilder.create({
          search: {
            $or: [
              {
                email: {
                  [CondOperator.EQUALS_LOW]: term
                }
              }
            ]
          }
        })
      })
    )

    this.members$ = this.store
      .select(memberSelectors.selectAll)
      .pipe(
        map((members) =>
          members.filter(
            (member) =>
              member?.email?.toLowerCase() == term.toLowerCase() ||
              member?.memberNumber == parseInt(term)
          )
        )
      )
  }

  public onSelectMember(member: Member) {
    this.selectedMember = member
  }

  public onFormSubmit(confirmation) {
    this.onSubmit.emit(confirmation)
  }
}
